<template>
  <svg id="LOGO" data-name="LOGO" xmlns="http://www.w3.org/2000/svg" viewBox="168 44 138 102" aria-label="Mesylab" v-bind="$attrs">
    <path fill="#437585" d="M289.5,49.56H227.13A9.18,9.18,0,0,0,218,58.73V96.41a9.18,9.18,0,0,0,9.17,9.17h16.74v-7H227.13A2.2,2.2,0,0,1,225,96.41V58.73a2.2,2.2,0,0,1,2.17-2.17H289.5a2.2,2.2,0,0,1,2.17,2.17V96.41a2.2,2.2,0,0,1-2.17,2.17H277v11.19L265.84,98.58h-8v7h5.07l13.34,13.34A4.54,4.54,0,0,0,284,115.7V105.58h5.47a9.18,9.18,0,0,0,9.17-9.17V58.73A9.18,9.18,0,0,0,289.5,49.56Z"/>
    <path fill="#344c77" d="M245.2,69.08H228.46v7H245.2a2.2,2.2,0,0,1,2.17,2.17v37.69a2.2,2.2,0,0,1-2.17,2.17H206.5l-11.19,11.19V118.1H182.84a2.2,2.2,0,0,1-2.17-2.17V78.24a2.2,2.2,0,0,1,2.17-2.17h31.63v-7H182.84a9.18,9.18,0,0,0-9.17,9.17v37.69a9.18,9.18,0,0,0,9.17,9.17h5.47v10.12a4.54,4.54,0,0,0,7.75,3.22L209.4,125.1h35.8a9.18,9.18,0,0,0,9.17-9.17V78.24A9.18,9.18,0,0,0,245.2,69.08Z"/>
  </svg>
</template>

<script>
export default {
  name: 'LogoComponent',
  inheritAttrs: false
}
</script>
